import React, { Fragment, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { compose, withState } from 'recompose'
import { Link } from 'react-router-dom'

import UsersList from './List'
import { Button, Text } from 'components/base'
import { getOrganization } from 'data/organizations/selectors'
import { canCurrentUserManageUsers } from 'data/users/selectors'
import RoutesHelper from 'helpers/RoutesHelper'
import { providesUsersSubscriptions } from 'components/Users/dataSync'
import providesPaginatedUsers from 'components/Users/dataSync/providesPaginatedUsers'
import { createSelector } from 'reselect'
import { getEntityMap } from 'data'

const LIST_NAME = 'SETTINGS_ORGANIZATION_MEMBERS'

const getOrganizationMembers = createSelector(
  state => getEntityMap(state, 'User'),
  (state, listState) => listState,
  (state, listState, includeArchived) => includeArchived,
  (users, listState, includeArchived) => {
    return listState.nodes
      .map(id => users.get(id))
      .filter(user => includeArchived || !user.archivedAt)
      .filter(Boolean)
  }
)

function SettingsOrganizationsMembers({
  includeArchived,
  setIncludeArchived,
  listState,
  fetchNextPage,
  reset,
}) {
  const canManage = useSelector(canCurrentUserManageUsers)
  const organization = useSelector(getOrganization)
  const users = useSelector(state =>
    getOrganizationMembers(state, listState, includeArchived)
  )
  const isLoading =
    listState.pristine || (listState.loading && listState.pristine)

  useEffect(
    () => {
      fetchNextPage({ startFresh: true })
    },
    [includeArchived, fetchNextPage]
  )

  const style = { width: 700 }

  return (
    <Fragment>
      <div
        className="flexbox flexbox-align-center margin-bottom-large margin-left-auto margin-right-auto"
        style={style}
      >
        {canManage && (
          <Link
            className="margin-left-auto"
            to={RoutesHelper.settingsInvitations()}
          >
            <Button.Primary>Invite members</Button.Primary>
          </Link>
        )}
      </div>

      {isLoading && (
        <div style={style} className="margin-left-auto margin-right-auto">
          loading
        </div>
      )}

      {!isLoading && (
        <Fragment>
          <UsersList
            listState={listState}
            loadMore={fetchNextPage}
            organization={organization}
            canManage={canManage}
            users={users}
          />

          <Text.Action
            className="margin-bottom-large margin-left-auto margin-right-auto"
            style={{ width: 700 }}
            onClick={() => {
              reset()
              setIncludeArchived(!includeArchived)
            }}
          >
            {includeArchived ? 'Hide removed members' : 'Show removed members'}
          </Text.Action>
        </Fragment>
      )}
    </Fragment>
  )
}

export default compose(
  withState('includeArchived', 'setIncludeArchived', false),
  providesPaginatedUsers({
    listName: LIST_NAME,
    resetOnUnmount: true,
    orderField: 'username',
    orderDirection: 'ASC',
  }),
  providesUsersSubscriptions
)(React.memo(SettingsOrganizationsMembers))
